import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import cn from 'clsx';
import * as React from 'react';

import { Card } from './Card';
import buyerPic from './buyer.svg';
import realtorPic from './realtor.svg';
import sellerPic from './seller.svg';
import * as styles from './styles.css';
import { trackOurBuyersShow, trackOurSellersShow } from '../../analytics';

interface IOurEstimatorsProps {
  className?: string;
  isAgent?: boolean;
}

export const OurEstimators: React.VFC<IOurEstimatorsProps> = ({ isAgent, className }) => {
  return (
    <div className={cn(styles['container'], className)} data-name="our_estimators">
      {isAgent && (
        <Card
          imgSrc={realtorPic}
          title="Риелтору"
          text="Отправьте отчёт от своего имени. Уточните параметры объекта и список аналогов. Укажите цену в диапазоне оценки и получите значок «Хорошая цена»."
        />
      )}
      {!isAgent && (
        <ActionAfterViewObserver callback={trackOurBuyersShow} callbackDelay={1500} wrapper={false}>
          <Card
            imgSrc={buyerPic}
            title="Покупателю или арендатору"
            text="Узнайте рыночную стоимость: можно поторговаться и не переплачивать"
          />
        </ActionAfterViewObserver>
      )}
      <ActionAfterViewObserver callback={trackOurSellersShow} callbackDelay={1500} wrapper={false}>
        <Card
          imgSrc={sellerPic}
          title="Продавцу"
          text="Укажите в объявлении цену в диапазоне оценки и получите значок «Хорошая цена» — это привлечёт больше внимания"
        />
      </ActionAfterViewObserver>
    </div>
  );
};
